import React from 'react'
import {Select, Spin, Tag} from 'antd'
import '../../asset/less/component.css'
import {getArtworkCollection, getArtworkCollectionAdmin} from '../../api/artworkCollections'
import HttpError from '../base/HttpError'
import {connect} from "react-redux";

const {Option} = Select

@connect((state) => ({
    //decorator, gives component access to the state
    artistId: state.user.info.artistId,
    role: state.user.info.role
}))
class ArtworkCollectionSelect extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            option_array: []
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        })
        const request_func = this.props.role === 'artist' ? getArtworkCollection : getArtworkCollectionAdmin
        request_func(1, 1000000, this.props.artistId)
            .then(async (response) => {
                let array = []
                response.data.results.forEach((item) => {
                    array.push(
                        <Option key={item.id}>
                            id-{item.id}: {item.title}
                        </Option>
                    )
                })
                this.setState({
                    option_array: array
                })
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    render() {
        function tagRender(props) {
            const {value, closable, onClose} = props
            const onPreventMouseDown = (event) => {
                event.preventDefault()
                event.stopPropagation()
            }
            return (
                <Tag color={'#' + value} onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose}
                     style={{marginRight: 3}}>
                    {value}
                </Tag>
            )
        }

        return (
            <Spin spinning={this.state.loading}>
                <Select
                    placeholder='please select from your collection'
                    {...this.props}
                    allowClear
                    showArrow
                    tagRender={tagRender}
                    style={{width: '100%'}}
                >
                    {this.state.option_array}
                </Select>
            </Spin>
        )
    }
}

export default ArtworkCollectionSelect
